import moment from "moment";

export const safeMoment = (value: any) => {
  if (!value || value === "-") return null;

  const m = moment(value, moment.ISO_8601, true);
  return m.isValid() ? m : null;
};
